// extracted by mini-css-extract-plugin
export default {"btn":"style_btn__wao-8","prevImg":"style_prevImg__yq756","infoBox":"style_infoBox__ie-3Q","head":"style_head__KXxEp","info":"style_info__qVaLo"};